import React from 'react';
import { RichText } from 'components/rich-text/RichText';
import { ColumnSection } from 'components/column-section/ColumnSection';
import { ColumnSectionItem } from 'components/column-section/ColumnSectionItem';

export const ColumnSectionSlice = ({ tagline, title, image, numbered, color, items, isSlice }) => {
  return (
    <ColumnSection
      tagline={tagline}
      title={title}
      image={image}
      numbered={numbered}
      color={color}
      isSlice={isSlice}
    >
      {items?.map((item, index) => (
        <ColumnSectionItem
          key={index}
          title={item.title}
          text={RichText.render(item.text)}
          link={item.link}
          label={item.label}
          icon={item.icon}
        />
      ))}
    </ColumnSection>
  );
};

export default ColumnSectionSlice;
